import React from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";
import { NavLink } from "react-router-dom";

export default function ConnectFooter({ data }) {
  const socials = [
    {
      type: "facebook",
      href: "https://www.facebook.com/profile.php?id=61555026071518",
    },
    {
      type: "youtube",
      href: "https://www.youtube.com/channel/UC0V6wNQd5-O-IzsuAlFuSZQ",
    },
    { type: "x", href: "https://twitter.com/HindusGlobally/media" },
    {
      type: "instagram",
      href: "https://www.instagram.com/connectinghindusglobally/",
    },
  ];

  return (
    <footer
      className="relative w-full"
      style={{ backgroundColor: "#7a2230" }}
      aria-label="Footer"
    >
      {/* top hairline */}
      <div className="h-[1px] w-full bg-white/15" />

      <div className="mx-auto  px-4 sm:px-6">
        <div className="py-3 sm:py-4 flex flex-col gap-2">
          {/* Row: Links + Socials */}
          {/* Row: Links + Socials */}
          <div className="grid items-center gap-2 sm:gap-0 sm:grid-cols-[1fr_auto_1fr]">
            {/* Left spacer */}
            <div className="hidden sm:block" />

            {/* Center Links */}
            <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[12px] sm:text-[13px]">
              {data?.map((item, idx) => (
                <a
                  key={`${item?.label}-${idx}`}
                  href={item?.url}
                  target="_blank"
                  rel="noreferrer"
                  className="
          text-white/90 hover:text-white
          transition
          underline-offset-4 hover:underline
        "
                >
                  {item?.title}
                </a>
              ))}
            </nav>

            {/* Socials Right */}
            <div className="flex items-center justify-center sm:justify-end gap-2">
              {socials?.map((s, idx) => {
                const Icon = socialIconMap[s?.type];
                if (!Icon || !s?.href) return null;
                return (
                  <a
                    key={`${s.type}-${idx}`}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    className="
            inline-flex h-8 w-8 items-center justify-center
            rounded-full border border-white/20
            bg-white/10 text-white/90
            hover:bg-white hover:text-[#7a2230]
            transition
          "
                    aria-label={s.type}
                    title={s.type}
                  >
                    <span className="text-[14px] leading-none">
                      <Icon />
                    </span>
                  </a>
                );
              })}
            </div>
          </div>

          {/* Divider */}
          <div className="h-[1px] w-full bg-white/15" />

          {/* Center copyright */}
          <div className="text-center text-[12px] text-white/85">
            Copyright © 2026
          </div>
        </div>
      </div>
    </footer>
  );
}

const socialIconMap = {
  facebook: FaFacebookF,
  youtube: FaYoutube,
  instagram: FaInstagram,
  linkedin: FaLinkedinIn,
  twitter: FaXTwitter,
  x: FaXTwitter,
};
